import PERMISSIONS from 'src/hooks/utils/usePermissionsByCompanyUser/permissions'

const distributor = {
  super_administration: [
    PERMISSIONS.claimCart,
    PERMISSIONS.cloneCart,
    PERMISSIONS.createCompanyUser,
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteCompany,
    PERMISSIONS.deleteCompanyUser,
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.exportCart,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.seeAvailability,
    PERMISSIONS.seeBetaMode,
    PERMISSIONS.seeGlobalSortOrder,
    PERMISSIONS.updateCompanyUser,
    PERMISSIONS.updateDistributionProductLists,
    PERMISSIONS.updateOrderBudget,
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCart,
  ],
  sales_coordination: [
    PERMISSIONS.claimCart,
    PERMISSIONS.cloneCart,
    PERMISSIONS.createCompanyUser,
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteCompany,
    PERMISSIONS.deleteCompanyUser,
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.exportCart,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.seeAvailability,
    PERMISSIONS.seeBetaMode,
    PERMISSIONS.seeGlobalSortOrder,
    PERMISSIONS.updateCompanyUser,
    PERMISSIONS.updateDistributionProductLists,
    PERMISSIONS.updateOrderBudget,
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCart,
  ],
  customer_service: [
    PERMISSIONS.claimCart,
    PERMISSIONS.cloneCart,
    PERMISSIONS.createCompanyUser,
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteCompanyUserWithRole('administration'),
    PERMISSIONS.deleteCompanyUserWithRole('customer_service'),
    PERMISSIONS.deleteCompanyUserWithRole('purchase'),
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.exportCart,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.postDefaultCompanyUser,
    PERMISSIONS.seeAvailability,
    PERMISSIONS.seeBetaMode,
    PERMISSIONS.seeGlobalSortOrder,
    PERMISSIONS.updateCompanyUserWithRole('administration'),
    PERMISSIONS.updateCompanyUserWithRole('customer_service'),
    PERMISSIONS.updateCompanyUserWithRole('purchase'),
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCart,
  ],
  order_management: [
    PERMISSIONS.claimCart,
    PERMISSIONS.cloneCart,
    PERMISSIONS.createCompanyUser,
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteCompanyUserWithRole('administration'),
    PERMISSIONS.deleteCompanyUserWithRole('order_management'),
    PERMISSIONS.deleteCompanyUserWithRole('purchase'),
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.exportCart,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.postDefaultCompanyUser,
    PERMISSIONS.seeAvailability,
    PERMISSIONS.seeBetaMode,
    PERMISSIONS.seeGlobalSortOrder,
    PERMISSIONS.updateCompanyUserWithRole('administration'),
    PERMISSIONS.updateCompanyUserWithRole('order_management'),
    PERMISSIONS.updateCompanyUserWithRole('purchase'),
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCart,
  ],
  distribution: [
    PERMISSIONS.claimCart,
    PERMISSIONS.cloneCart,
    PERMISSIONS.createCompanyUser,
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteCompanyUserWithRole('administration'),
    PERMISSIONS.deleteCompanyUserWithRole('purchase'),
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.exportCart,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.seeAvailability,
    PERMISSIONS.seeBetaMode,
    PERMISSIONS.updateCompanyUserWithRole('administration'),
    PERMISSIONS.updateCompanyUserWithRole('purchase'),
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCart,
  ],
  distribution_management: [
    PERMISSIONS.claimCart,
    PERMISSIONS.cloneCart,
    PERMISSIONS.createCompanyUser,
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteCompanyUserWithRole('administration'),
    PERMISSIONS.deleteCompanyUserWithRole('purchase'),
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.exportCart,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.seeAvailability,
    PERMISSIONS.seeBetaMode,
    PERMISSIONS.updateCompanyUserWithRole('administration'),
    PERMISSIONS.updateCompanyUserWithRole('purchase'),
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCart,
  ],
  administration: [
    PERMISSIONS.cloneCart,
    PERMISSIONS.createCompanyUser,
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteCompanyUserWithRole('administration'),
    PERMISSIONS.deleteCompanyUserWithRole('purchase'),
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.exportCart,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.postDefaultCompanyUser,
    PERMISSIONS.selectCompanyForAvailabilitySearch,
    PERMISSIONS.updateCompanyUserWithRole('administration'),
    PERMISSIONS.updateCompanyUserWithRole('purchase'),
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCartAsRetailer,
  ],
  purchase: [
    PERMISSIONS.createShippingAddress,
    PERMISSIONS.deleteShippingAddress,
    PERMISSIONS.mergeDeliveryDates,
    PERMISSIONS.postDefaultCompanyUser,
    PERMISSIONS.selectCompanyForAvailabilitySearch,
    PERMISSIONS.updateShippingAddress,
    PERMISSIONS.uploadCartAsRetailer,
  ],
}

export default distributor
